<template>
  <product
    :product-logo="productLogo"
    :product-brief="productBrief"
    :carousel-items-no="1"
    :carousel-images="carouselImages"
  >
    <p>
      Omnivia App offers a whole new look at how we interact with doctors and keep track of our health overall.
      This platform is what I always imagined the future of medicine would be. So It was pleasant for me to work on something like this.
    </p>
    <p>
      The product consists of a mobile app (to gather users' vitals from numerous devices)
      and a Web UI (for doctors to review and make conclusions based on the received data).
      On top of that, Web UI needed to have an admin area to manage clinics and for clinics to manage their patients.
      My job was to create a Web UI part and set up data structure/restrictions to prevent unauthorized access.
    </p>
    <p>
      As we were building an app - we did the following:
      <ul>
        <li>
          Super Admin area - For Omnivia team to register/manage Clients (Clinics).
        </li>
        <li>
          Clinic admin area - Gives access to a particular clinic. Here, clinics would manage their staff and patients.
          It's also the place where doctors here can treat their patients.
        </li>
        <li>
          Patient area, for people to review their medical info and chat with their doctors in real-time.
        </li>
        <li>
          Data is presented as a table and as charts featuring progress/vitals over a given period.
        </li>
        <li>
          Doctors can enable/disable particular devices for patients. Doing so would also impact the data that a patient can see.
        </li>
        <li>
          We've also set up a notifications system that notifies users about new chat messages and reminds them to use the measuring devices on time.
        </li>
      </ul>
    </p>
    <p>
      As a result - a product was built successfully. We're now going live and planning the next steps.
    </p>

    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn">
        <router-link :to="{ name: 'halden' }">
          <span>Next &mdash; Real Estate CMS</span>
          <font-awesome-icon icon="arrow-right" size="3x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/Omnivia.png'),
      productBrief: 'Monitoring your health online and in real-time',
      carouselImages: [
        require('@/assets/img/products/omn/2.png'),
        require('@/assets/img/products/omn/6.png'),
        require('@/assets/img/products/omn/3.png'),
        require('@/assets/img/products/omn/7.png'),
        require('@/assets/img/products/omn/4.png'),
        require('@/assets/img/products/omn/8.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
section.main {
  background-image: linear-gradient(#595d694a, #1e1e1f4e),
    url('~@/assets/img/products/omn/cover.jpg');
  background-position: bottom center;
}
</style>
